import { render, staticRenderFns } from "./Info-student.vue?vue&type=template&id=c90326fe&"
import script from "./Info-student.vue?vue&type=script&lang=js&"
export * from "./Info-student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports